// extracted by mini-css-extract-plugin
export default {"stories":"Stories_stories__+2W49"};